module.exports = __webpack_public_path__ + "img/honour-pic-10.9aa2d58a.png";